import { useWatch } from 'react-hook-form';
import { Box, Grid, Typography } from '@mui/material';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import SectionHeader from '../../../components/shared/SectionHeader';
import TextField from '../../../components/form/TextField';
import SelectField from '../../../components/form/SelectField';
import NumberField from '../../../components/form/NumberField';
import CurrencyField from '../../../components/form/CurrencyField';
import CheckboxField from '../../../components/form/CheckboxField';
import { UFF_LICENSED_STATES } from '../../../constants/usStates';

const PROPERTY_TYPE_OPTIONS = [
  { value: 'Single Family', label: 'Single Family Residence' },
  { value: 'Condominium', label: 'Condominium' },
  { value: 'Townhouse', label: 'Townhouse' },
  { value: '2-4 Unit', label: '2-4 Unit Property' },
  { value: 'Manufactured Home', label: 'Manufactured/Mobile Home' },
];

const OCCUPANCY_OPTIONS = [
  { value: 'Primary Residence', label: 'Primary Residence' },
  { value: 'Second Home', label: 'Second Home' },
  { value: 'Investment', label: 'Investment Property' },
];

const PropertyStep = () => {
  const loanPurpose = useWatch({ name: 'loanDetails.loanPurpose' });
  const isRefi = loanPurpose === 'Refinance' || loanPurpose === 'Cash-Out Refinance';

  return (
    <Box>
      <SectionHeader title="Property Information" icon={<HomeWorkIcon />} />
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {isRefi
          ? 'Details about the property you are refinancing'
          : 'Details about the property you are purchasing'}
      </Typography>

      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField name="property.address" label="Property Address" required size="small" />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField name="property.city" label="City" required size="small" />
        </Grid>
        <Grid size={{ xs: 6, sm: 3, md: 3 }}>
          <SelectField name="property.state" label="State" required options={UFF_LICENSED_STATES} size="small" />
        </Grid>
        <Grid size={{ xs: 6, sm: 3, md: 3 }}>
          <TextField name="property.zip" label="ZIP" required size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 3 }}>
          <TextField name="property.county" label="County" size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CurrencyField
            name="property.propertyValue"
            label={isRefi ? 'Estimated Current Value' : 'Estimated Property Value'}
            size="small"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SelectField name="property.propertyType" label="Property Type" options={PROPERTY_TYPE_OPTIONS} size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SelectField name="property.occupancyType" label="Occupancy Type" options={OCCUPANCY_OPTIONS} size="small" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <NumberField name="property.unitsCount" label="Number of Units" fullWidth size="small" min={1} />
        </Grid>
        <Grid size={12}>
          <CheckboxField name="property.mixedUse" label="This is a mixed-use property" />
        </Grid>
        <Grid size={12}>
          <CheckboxField name="property.manufacturedHome" label="This is a manufactured home" />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PropertyStep;
